import { DownloadOutlined } from "@mui/icons-material"
import { Box, IconButton, Tooltip } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

// One control for both places it appears. The card and the detail header each had their own copy, which had
// already drifted apart on size, and neither is the primary action where it sits — the enable switch is.
//
// No colour of its own: MuiIconButton has no app-level override, so the theme default (action.active, and
// action.hover for the hover) is the standard icon-button treatment every other icon button here gets, in
// both schemes. Forcing --app-text-secondary made it a shade darker than the rest and read as black.
// Placement is the caller's job too, so the look cannot drift again.
const WRAPPER_SX = { display: "inline-flex" } satisfies SxProps<Theme>

interface SkillDownloadButtonProps {
  skillName: string
  isDownloading: boolean
  onDownload: () => void
}

export function SkillDownloadButton({ skillName, isDownloading, onDownload }: SkillDownloadButtonProps) {
  return (
    <Tooltip title="Download skill">
      {/* The span keeps the tooltip alive while the button is disabled mid-download. */}
      <Box component="span" sx={WRAPPER_SX}>
        <IconButton
          aria-label={`Download ${skillName}`}
          disabled={isDownloading}
          loading={isDownloading}
          onClick={onDownload}
        >
          <DownloadOutlined />
        </IconButton>
      </Box>
    </Tooltip>
  )
}
